import {
    createTable,
    RenderingPresetType,
    TableHeaderSpec
} from "../../../../../components/table/CreateTable.tsx";
import {DoublePayment} from "./DoublePayment.tsx";


interface Props {
    data: Array<DoublePayment>,
}

export function DoublePaymentsTable({data}: Props) {

    const tableSpec: TableHeaderSpec<DoublePayment> = {
        title: `${data.length} betalingen`,
        columns: [
            {
                name: 'Datum',
                field: 'date',
            },
            {
                name: 'Leverancier',
                field: 'relation_name',
            },
            {
                name: 'Omschrijving',
                field: 'description'
            },
            {
                name: 'Bedrag',
                field: 'amount',
                renderingPreset: RenderingPresetType.Money
            },
        ],
        options: {
            disableTopPaginationWidget: true,
        },
    }

    const TableComponent = createTable<DoublePayment>(data, tableSpec)

    return (
        <>
            {TableComponent()}
        </>
    )
}
